import React from 'react';
import { CELL_W, CELL_H } from './casual-voronoi-cell';

/**
 * Segnaposto della foto del profilo nella variante Voronoi.
 *
 * Non disegna niente. Sembra strano, ed e' invece il punto dell'intero
 * approccio: la foto e la sua cella le disegna VoronoiHeader, dentro il proprio
 * SVG, nello stesso sistema di coordinate della tassellazione. Finche' stavano
 * in un SVG separato erano due sistemi di riferimento distinti da tenere
 * allineati a mano - misurando un rettangolo, indovinando come il browser
 * scalava il viewBox, replicando il poligono in due file - e ogni stato in cui
 * le proporzioni divergevano (l'header minificato, che forza l'altezza e non la
 * larghezza) li disallineava.
 *
 * Quello che resta a questo elemento sono i due compiti che soltanto un elemento
 * in pagina puo' svolgere:
 *
 *  1. RISERVARE LO SPAZIO nella colonna. La griglia Bootstrap e le regole di
 *     header.scss dimensionano `svg#profileimage`, comprese le transizioni fra
 *     header espanso e minificato: mantenendo lo stesso id e lo stesso viewBox,
 *     quelle regole continuano a valere senza modifiche, e il rettangolo che ne
 *     risulta e' cio' che VoronoiHeader misura per sapere dove va la cella.
 *  2. FARE DA ANCORA al fumetto di TalkToMeBubble, che si posiziona in absolute
 *     rispetto al genitore.
 *
 * Non porta aria-hidden: e' vuoto, non ha contenuto da nascondere, e la foto che
 * rappresenta e' decorativa (il nome sta nel testo dell'header, accanto).
 */
const CasualVoronoiImageSvg: React.FC = () => {
  return (
    <svg
      width={`${CELL_W}mm`}
      height={`${CELL_H}mm`}
      viewBox={`0 0 ${CELL_W} ${CELL_H}`}
      id="profileimage"
      xmlns="http://www.w3.org/2000/svg"
    />
  );
};

export default CasualVoronoiImageSvg;
